import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-bs-title"]

import { onMounted, watch, nextTick } from 'vue';
import { Tooltip } from 'bootstrap';
import { userLangStore } from '@/store/userLangStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'TopNavbarGame',
  setup(__props) {

const lang = userLangStore();

watch(() => lang.refreslang, async () => {
	await nextTick();
	initTooltip();
});

onMounted(
	async () => {
		initTooltip();

	});

function initTooltip() {
	const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
	[...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_link, {
      onClick: _ctx.$scrollToTop,
      to: "/g/1",
      id: "game-btn",
      "aria-current": "page",
      class: "d-none d-lg-block nav-link game-btn text-nowrap",
      "data-bs-html": "true",
      "data-bs-toggle": "tooltip",
      "data-bs-placement": "bottom",
      "data-bs-custom-class": "custom-tooltip",
      "data-bs-title": `<div class='tooltip-body'>${ _ctx.$t('games.topmenutooltip', 'Play our game Land of Titans and learn game design by doing, not just watching. Play the First Level Free') }</div>`
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('games.topmenucta', 'Play & Learn')), 1)
      ]),
      _: 1
    }, 8, ["onClick", "data-bs-title"]),
    _createElementVNode("div", {
      id: "game-btn",
      role: "button",
      "aria-current": "page",
      class: "d-lg-none nav-link game-btn text-nowrap",
      "data-bs-html": "true",
      "data-bs-toggle": "tooltip",
      "data-bs-placement": "bottom",
      "data-bs-custom-class": "custom-tooltip",
      "data-bs-title": `<div class='tooltip-body'>${ _ctx.$t('games.topmenutooltipm', 'Desktop version is availabe. Please, use your desktop computer') }</div>`
    }, _toDisplayString(_ctx.$t('games.topmenucta', 'Play  & Learn')), 9, _hoisted_1)
  ], 64))
}
}

})